import React from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { getSetting, setSetting } from '../../common/store';
import { withTranslation, Trans } from 'react-i18next';
import Link from '../../components/net/link';

class JoinForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {email: '', motivation: '', validated: false, has_errors: false};
  }

  componentDidMount() {
    //maybe the footer set a value for email
    if (getSetting('joinemail')) {
      this.setState({email: getSetting('joinemail')});
      //and now remove the address from the state
      //because it was a "auto-navigation" to get here
      setSetting('joinemail', undefined);
    }
  }


  handleSubmit(event) {
    event.preventDefault();

    if (this.state.email === '') {
      event.preventDefault();
      event.stopPropagation();
    } else {

    


    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      let data = {
        email: this.state.email,
        motivation: this.state.motivation
      }
      this.props.onSubmit(data);
    }


    this.setState({validated: true});
  }
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  render() {
    const { t } = this.props;
    return (
      <>

      {this.props.serverError ? <Alert variant="danger"><Alert.Heading>{t('joinform.error_header')}</Alert.Heading>
      <Trans i18nKey="joinform.error_body">
      <p>Something went wrong with processing your request. We couldn't talk to our server, please try again after some time. If the error perists, please <Alert.Link href="mailto:support@nutrfy.com">contact us</Alert.Link> and we can sort this out together.</p></Trans></Alert> : 

      <p>{t('joinform.intro')}
      </p>
    }

      <Form onSubmit={this.handleSubmit} noValidate validated={this.state.validated}>

        <Form.Group>
          <Form.Label>{t('joinform.email_label')}</Form.Label>
          <Form.Control name="email" type="email" placeholder={t('joinform.email_placeholder')}  value={this.state.email} onChange={this.handleChange} isValid={this.state.valid_email}/>
          <Form.Control.Feedback type="invalid">{t('joinform.email_error')}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <Form.Label>{t('joinform.motivation_label')}</Form.Label>
          <Form.Control name="motivation" type="text" placeholder={t('joinform.motivation_placeholder')}  value={this.state.motivation} onChange={this.handleChange}/>
          <Form.Text className="text-muted">
            {t('joinform.motivation_text')}
          </Form.Text>
        </Form.Group>
        <Button variant="primary" type="submit">
          {t('joinform.submit')}
          </Button>
          <div className="small mt-2"><Trans i18nKey='joinform.acknowledge'>By clicking submit, you acknowledge our <Link to='/privacy-statement'>Privacy Policy</Link> and our <Link to='/terms-and-conditions'>Terms and Conditions</Link>.</Trans></div>
      </Form>
      </>
    )
  }
}
export default withTranslation()(JoinForm);